<template>
  <section
    class="containerOptionsNotification"
    :style="general ? '--right: 52px; --top: 21px' : '--right: 27px; --top: 5px'"
    @click.stop>
    <ul class="containerOptionsNotification__containerOptions">
      <li v-for="(item, index) in optionsFiltered" :key="index"
        class="containerOptionsNotification__containerOptions--item"
        @click.stop="manageEvent($event, item.action)"
      >
        <span :class="item.icon" class="icon"></span>
        <span class="label">{{item.name}}</span>
      </li>
    </ul>
  </section>
</template>

<script>
import { onMounted, ref } from 'vue'

export default {
  name: 'optionsNotification',
  props: {
    options: {
      type: Array,
      required: true
    },
    notification: {
      type: Object,
      required: false
    },
    general: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const optionsFiltered = ref([])

    onMounted(() => {
      optionsFiltered.value = props.options.filter(option => !option.validate ? true : !props.notification.isRead)
    })

    /**
     * @description Calls a method of the current context.
     * @param event DOM event
     * @param methodName string with the name of the method.
     */
    function manageEvent (event, methodName) {
      event.preventDefault()
      event.stopPropagation()
      emit(methodName, props.notification)
    }

    return {
      optionsFiltered,
      manageEvent
    }
  }
}
</script>
